import React from 'react';
import PropTypes from 'prop-types';
import { WarningOutlined } from '@ant-design/icons';

import OnTraccrButton from '../common/buttons/OnTraccrButton';
import Colors from '../constants/Colors';

const EMPTY_COLOR_STYLE = { color: Colors.ONTRACCR_ERROR };
const EMPTY_BUTTON_STYLE = {
  backgroundColor: '#FFFFFF',
  borderColor: Colors.ONTRACCR_ERROR,
  color: Colors.ONTRACCR_ERROR,
};

export default function DuplicateConflictButton({ duplicateCount, onClick, style }) {
  const isEmpty = duplicateCount === 0;

  return (
    <OnTraccrButton
      type="back"
      icon={<WarningOutlined style={isEmpty ? EMPTY_COLOR_STYLE : undefined} />}
      title={`${duplicateCount} Conflict${duplicateCount !== 1 ? 's' : ''} Detected`}
      onClick={onClick}
      style={isEmpty ? { ...style, ...EMPTY_BUTTON_STYLE } : style}
      titleStyle={isEmpty ? EMPTY_COLOR_STYLE : undefined}
    />
  );
}

DuplicateConflictButton.propTypes = {
  duplicateCount: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  style: PropTypes.shape({}),
};

DuplicateConflictButton.defaultProps = {
  style: {},
};
